import { createSlice } from "@reduxjs/toolkit";
import services from "../services";

interface PostsState {
    loading: boolean;
    error: boolean;
}

const initialState: PostsState = {
    loading: false,
    error: false,
};

const postsSlice = createSlice({
    name: "posts",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const { setLoading, setError } = postsSlice.actions;

export default postsSlice.reducer;

export const updatePostPosition =
    (positions: number[]) =>
    async (dispatch: any) => {
        try {
            dispatch(setLoading(true));
            await services.updatePostPosition(positions);
            dispatch(setLoading(false));
        } catch (err) {
            console.error("Erro ao atualizar posições:", err);
            dispatch(setError(true));
        }
    };
